import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class LoginRepository {
    static async getmobile(phoneNumber, countryCode, pass) {
        const f = countryCode + phoneNumber;
        const data = {
            phoneNumber: f,
            password: pass,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/auth/get-mobile", data)
            });
        let SMSId = undefined;
        const code = response.statusCode;
        const message = response.message;
        if (response.success) {
            SMSId = response.data.smsId;
        }

        return {
            SMSId,
            code,
            message,
        };
    }

    static async checkotp(setsmsId, otp) {
        const data = {
            smsId: setsmsId,
            code: otp,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/auth/check-otp-v2", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        if (response.success) {
            const token = response.data.accessToken;
            const refreshToken = response.data.refreshToken;
            const role = response.data.role;
            return {
                code,
                massage,
                token,
                refreshToken,
                role
            };

        }
        return {
            code,
            massage,
        }

    }
}

export {LoginRepository};
